import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10a274a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-item-id", "onMouseup"]

import { onMounted, onUnmounted, PropType, ref, watch } from "vue";
import TirPmFilePreview from "../../tir-pm-file-preview.vue";
import { IFilePreview } from "../../interfaces";
import { FilePreviewVariantEnum } from "../../enums";
import { TirPmScrollbar } from "tir-pm-scrollbar";


export default /*#__PURE__*/_defineComponent({
  __name: 'file-preview-carousel',
  props: {
  /**Выбранный файл */
  selectedFile: {
    type: Object as PropType<IFilePreview>,
  },
  /**Список файлов */
  files: {
    type: Array as PropType<Array<IFilePreview>>,
    required: true,
  },
  /**Скорость перетаскивания */
  dragSpeed: {
    type: Number,
    default: 1.15,
  },
},
  emits: ["selectFile"],
  setup(__props, { emit }) {

const props = __props;





/**Ссылка на элемент строки в карусели */
const $carouselRow = ref<HTMLElement>();
/**Ссылка на элемент скроллбара */
const $scrollbar = ref<InstanceType<typeof TirPmScrollbar>>();
const $scrollContainer = ref<HTMLElement>();

const scrollToSelectedFile = (smooth: boolean = true) => {
  if (!props.selectedFile) return;
  const scrollToElement = $carouselRow.value?.querySelector(
    `[data-item-id="${props.selectedFile.FileId}"]`
  ) as HTMLElement | undefined;
  if (!scrollToElement) return;
  $scrollbar.value.$scroll?.scrollTo({
    top: 0,
    left:
      scrollToElement.offsetLeft -
      $scrollbar.value.$scroll.offsetWidth / 2 +
      72.5,
    behavior: smooth ? "smooth" : "auto",
  });
};

watch(
  () => props.selectedFile?.FileId,
  () => scrollToSelectedFile(true)
);

const isDragging = ref(false);
const isDown = ref(false);
let startX: number;
let scrollLeft: number;
let startScrollLeft: number;

const handleMouseDown = (e: MouseEvent) => {
  isDown.value = true;
  isDragging.value = false;
  startX = e.pageX - $scrollContainer.value!.offsetLeft;
  scrollLeft = $scrollbar.value!.$scroll.scrollLeft;
  startScrollLeft = scrollLeft;
  document.body.style.cursor = "grabbing";
};

const handleMouseLeaveOrUp = () => {
  isDown.value = false;
  isDragging.value = false;
  document.body.style.removeProperty("cursor");
};

const handleMouseMove = (e: MouseEvent) => {
  if (!isDown.value) return;
  const x = e.pageX - $scrollContainer.value!.offsetLeft;
  const walk = (x - startX) * props.dragSpeed;

  $scrollbar.value!.$scroll.scrollLeft = scrollLeft - walk;
};

const handleClick = (file: IFilePreview) => {
  if (
    !isDown.value ||
    Math.abs(startScrollLeft - ($scrollbar.value?.$scroll?.scrollLeft || 0)) <= 20
  ) {
    emit("selectFile", file);
  }
};

onMounted(() => {
  scrollToSelectedFile(false);
  $scrollContainer.value?.addEventListener("mousedown", handleMouseDown);
  window.addEventListener("mouseleave", handleMouseLeaveOrUp);
  window.addEventListener("mouseup", handleMouseLeaveOrUp);
  window.addEventListener("mousemove", handleMouseMove);
});

onUnmounted(() => {
  $scrollContainer.value?.removeEventListener("mousedown", handleMouseDown);
  window.removeEventListener("mouseleave", handleMouseLeaveOrUp);
  window.removeEventListener("mouseup", handleMouseLeaveOrUp);
  window.removeEventListener("mousemove", handleMouseMove);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "file-preview-carousel",
    ref_key: "$scrollContainer",
    ref: $scrollContainer
  }, [
    _createVNode(_unref(TirPmScrollbar), {
      ref_key: "$scrollbar",
      ref: $scrollbar
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['file-preview-carousel__row', { 'is-grabbing': isDown.value }]),
          ref_key: "$carouselRow",
          ref: $carouselRow
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.files, (file) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "file-preview-carousel__item",
              "data-item-id": file.FileId,
              key: file.FileId,
              onMouseup: ($event: any) => (handleClick(file))
            }, [
              _createVNode(TirPmFilePreview, {
                file: file,
                variant: _unref(FilePreviewVariantEnum).Small,
                "is-disabled-open": true,
                "hide-controls": true,
                "is-selected": __props.selectedFile && __props.selectedFile.FileId === file.FileId
              }, null, 8, ["file", "variant", "is-selected"])
            ], 40, _hoisted_1))
          }), 128))
        ], 2)
      ]),
      _: 1
    }, 512)
  ], 512))
}
}

})